import { render, staticRenderFns } from "./ProductStocks.vue?vue&type=template&id=b7b3f816&scoped=true&lang=html&"
import script from "./ProductStocks.vue?vue&type=script&lang=js&"
export * from "./ProductStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b3f816",
  null
  
)

export default component.exports